import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { userAccountTypes, userTypes } from '../../../../types/user';
import { addressTypes } from '../../../../types/address';

import { addresses, mergedAddresses, sapAddresses } from '../../../../addressBook/selectors';
import { requestAddresses, requestSapAddresses } from '../../../../addressBook/actions';
import { openModal, closeModal } from '../../../../components/modal/actions';
import { addOrderShippingAddress } from '../../../../orders/actions';
import { visible } from '~COMPONENTS/modal/reducer';

import { getUserAccount, getUserData, getOrderShippingAddress } from '../../../../user/selectors';

import { TranslatedCopy } from '../../../../intl/TranslatedCopy';
import { H1, H2, Button } from '../../../../components';
import Input from '~COMPONENTS/formInputs/Input';

import OrderReturnsAddressBook from '../../OrderReturnsAddressBook';

import {
  minLength3,
  maxLength55,
  required,
  phoneMinLength,
  phoneMaxLength,
  extMaxLength,
  ext,
  email,
  phone
} from '~APP_UTIL/formValidations';
import { groupBy, isEqual } from '../../../../util/lodash';

export class OrderReturnsPageFinalContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayAddress: props.currentAddress
    };
  }

  componentDidUpdate({ addresses: prevAddresses }) {
    const { addresses: currAddresses, modalVisible } = this.props;

    // If new addresses don't match previous, update the currently displayed address
    const prevAddressesById = Object.entries(groupBy(prevAddresses, 'id'));
    const currAddressesGrouped = groupBy(currAddresses, 'id');

    const arrayIsEqual =
      prevAddressesById.length === Object.entries(currAddressesGrouped).length &&
      prevAddressesById.every(([id, obj]) => isEqual(currAddressesGrouped[id], obj));

    if (!arrayIsEqual) {
      this.updateDisplayAddress();

      // If the modal is currently displayed, rerender the modal with the new Addresses
      if (modalVisible) this.changeAddressClicked();
    }
  }

  onValueChange = e => {
    const { onFormValueUpdate } = this.props;
    onFormValueUpdate(e.target.defaultValue, e.target.id);
  };

  getAvailableAddress = () => {
    const { allAddresses, user } = this.props;
    if (allAddresses && allAddresses.length > 0) {
      return allAddresses.filter(addr => addr.userId === user.id)[0] || allAddresses[0];
    }
    return {};
  };

  fetchAddresses = () => {
    const { requestAddresses, user } = this.props;
    if (user) requestAddresses();
  };

  updateDisplayAddress = (address = null) => {
    const { setCurrentAddress } = this.props;
    const displayAddress = address || this.getAvailableAddress();

    this.setState({ displayAddress });
    setCurrentAddress(displayAddress);
  };

  handleSetAddress = (param = null) => {
    const { closeModal, addOrderShippingAddress } = this.props;
    if (param && (param.id || param.addressLine1)) {
      this.updateDisplayAddress(param);
      addOrderShippingAddress(param);
    }
    closeModal();
  };

  changeAddressClicked = () => {
    const { openModal, addresses, sapAddresses, shipToId } = this.props;

    openModal({
      type: 'custom',
      element: (
        <OrderReturnsAddressBook
          closeModal={this.handleCloseModal}
          addresses={addresses}
          sapAddresses={sapAddresses}
          shipToAddress={this.handleSetAddress}
          fetchAddresses={this.fetchAddresses}
          shipToId={shipToId}
        />
      ),
      cancelText: new TranslatedCopy({ id: 'global.button.cancel' }).toString(),
      cancelAction: this.handleSetAddress,
      confirmAction: this.handleSetAddress,
      title: new TranslatedCopy({ id: 'global.doubleCheck' }).toString(),
      noPadding: true,
      restrictedHeight: false
    });
  };

  render() {
    const { userAccount } = this.props;
    const { displayAddress } = this.state;
    return (
      <div
        className={classnames(
          'orderReturns__final orderReturns__finalContactContainer',
          'flex-container center u-full-width bg-white'
        )}
      >
        <div className='orderReturns__final_contact prl7-sm prl12-md pt6-sm pb6-sm u-full-width'>
          <H1>
            <TranslatedCopy id='orderreturns.contact.header' />
          </H1>
          <div
            className={classnames(
              'orderReturns__final_contact_section',
              'mt5-sm flex-container column start space-between u-full-width'
            )}
          >
            <div className='u-full-width mr7-lg'>
              <p className='body-4 text-color-warm-grey d-sm-h d-md-b'>
                <TranslatedCopy id='orderreturns.contact.copy' />
              </p>
              <H2 className='mt3-sm mt7-md'>{userAccount.name}</H2>
              {displayAddress ? (
                <ul className='body-4 mt2-sm mb3-sm pr1-sm text-color-warm-grey'>
                  {displayAddress.attention && displayAddress.attention.replace(/\s/g, '') !== '' && (
                    <li>
                      <p>
                        <TranslatedCopy id='global.attn.abbr' />
                        {': '}
                        {displayAddress.attention}
                      </p>
                    </li>
                  )}
                  <li>
                    <p>{displayAddress?.addressLine1 || ''}</p>
                    <p>{displayAddress?.addressLine2 || ''}</p>

                    <p>{displayAddress?.streetAddressLine1 || ''}</p>
                  </li>
                  <li>
                    <p>
                      {displayAddress?.city || new TranslatedCopy({ id: 'global.form.city' }).toString()}
                      {', '}
                      {displayAddress?.state || new TranslatedCopy({ id: 'global.form.state' }).toString()}
                      <> </>
                      {displayAddress?.zipCode || new TranslatedCopy({ id: 'global.form.zip' }).toString()}
                    </p>
                  </li>
                </ul>
              ) : (
                <div className='mt2-sm text-color-error'>
                  <TranslatedCopy id='checkout.info.noAddressSelected' />*
                </div>
              )}
              <Button onClick={this.changeAddressClicked} extraClassName='mr2-sm mt4-sm pb2-sm u-full-width' secondary>
                {displayAddress ? (
                  <TranslatedCopy id='orderreturns.contact.button' />
                ) : (
                  <TranslatedCopy id='checkout.shipping.select.address' />
                )}
              </Button>
            </div>
            <div className='orderReturns__final_form u-full-width ml7-lg mt5-sm mt0-lg'>
              <div className='orderReturns__final_form_name flex-container u-full-width'>
                <Field
                  name='contactName'
                  type='text'
                  component={Input}
                  label={new TranslatedCopy({ id: 'global.form.contactName' }).toString()}
                  validate={[minLength3, maxLength55, required]}
                  required
                  onBlur={this.onValueChange}
                />
              </div>
              <div className='orderReturns__final_form_phone flex-container column u-full-width'>
                <div className='u-full-width'>
                  <Field
                    name='contactPhoneNumber'
                    type='text'
                    component={Input}
                    label={new TranslatedCopy({ id: 'global.form.phone' }).toString()}
                    validate={[phone, phoneMinLength, phoneMaxLength, required]}
                    required
                    onBlur={this.onValueChange}
                  />
                </div>
                <div className='u-full-width pl0-sm pl6-lg'>
                  <Field
                    name='contactExtension'
                    type='text'
                    component={Input}
                    label={new TranslatedCopy({ id: 'global.form.phone.ext' }).toString()}
                    validate={[extMaxLength, ext]}
                    onBlur={this.onValueChange}
                  />
                </div>
              </div>
              <div className='orderReturns__final_form_email flex-container u-full-width'>
                <Field
                  name='contactEmail'
                  type='text'
                  component={Input}
                  label={new TranslatedCopy({ id: 'global.form.email' }).toString()}
                  validate={[email, maxLength55, required]}
                  required
                  onBlur={this.onValueChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OrderReturnsPageFinalContact.propTypes = {
  user: userTypes,
  userAccount: userAccountTypes,
  addresses: PropTypes.arrayOf(PropTypes.shape(addressTypes)),
  sapAddresses: PropTypes.arrayOf(PropTypes.shape(addressTypes)),
  allAddresses: PropTypes.array,
  requestAddresses: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  setCurrentAddress: PropTypes.func.isRequired,
  onFormValueUpdate: PropTypes.func.isRequired,
  modalVisible: PropTypes.bool.isRequired,
  addOrderShippingAddress: PropTypes.func.isRequired,
  currentAddress: PropTypes.object.isRequired,
  shipToId: PropTypes.string.isRequired
};

OrderReturnsPageFinalContact.defaultProps = {
  user: null,
  userAccount: null,
  addresses: null,
  sapAddresses: null,
  allAddresses: []
};

const mapStateToProps = state => ({
  user: getUserData(state),
  userAccount: getUserAccount(state),
  addresses: addresses(state),
  sapAddresses: sapAddresses(state),
  allAddresses: mergedAddresses(state),
  modalVisible: visible(state),
  orderShippingAddress: getOrderShippingAddress(state)
});

const connector = connect(mapStateToProps, {
  requestAddresses,
  requestSapAddresses,
  openModal,
  closeModal,
  addOrderShippingAddress
});

export default connector(OrderReturnsPageFinalContact);
